import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_BASE_HREF } from '@angular/common';

import { TransactionRunnerComponent } from './transaction-runner.component';
import { TermComponent } from './term.component';
import { UserInfoComponent } from './user-info.component';
import { CustomTransactionRunnerComponent } from './custom-transaction-runner.component';
import { SigninComponent } from './signin/signin.component';
import { AuthGuard } from './auth.guard';
const routes: Routes = [
    { path: '',  redirectTo: 'term/S100/', pathMatch: 'full'}, // Default route for signin
    { path: 'transaction-runner', component: TransactionRunnerComponent, canActivate: [AuthGuard] },
    { path: 'user-info', component: UserInfoComponent, canActivate: [AuthGuard] },
    { path: 'term/:transid/:commarea', component: TermComponent, canActivate: [AuthGuard] },
    { path: 'signin',  component: SigninComponent } ,
    { path: 'S100',redirectTo: 'term/S100/', pathMatch: 'full' },
    { path: 'term/:transid', component: TermComponent, pathMatch:'full' , canActivate: [AuthGuard]}
    // { path: 'custom-transaction-runner', component: CustomTransactionRunnerComponent },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash:true})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
